<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.550022 7.44998C0.301507 7.20146 0.301507 6.79854 0.550022 6.55002L6.91366 0.186386C7.16217 -0.062129 7.5651 -0.062129 7.81361 0.186386C8.06213 0.434903 8.06213 0.837825 7.81361 1.08634L1.89995 7L7.81361 12.9137C8.06213 13.1622 8.06213 13.5651 7.81361 13.8136C7.5651 14.0621 7.16217 14.0621 6.91366 13.8136L0.550022 7.44998Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgChevronLeft',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>